import { createSelector } from 'reselect';

// Config
import {
  getConfigFeaturesSelector,
  isBasketOrderTotalAlwaysVisibleFeatureActive,
} from '@redux/reducers/config/configSelector';
import {
  getConfirmationIsClickCollectOrderSelector,
  getConfirmationIsMultiBatchSelector,
  getConfirmationOrderAmountsSelector,
  getConfirmationOrderDeliveriesSelector,
  getConfirmationPromoCodeAppliedSelector,
} from '@redux/reducers/confirmation/orderConfirmationSelector';
import {
  getApplyRewardsApiCallActiveSelector,
  getOrderFormAmountsSelector,
  getOrderFormIsClickCollectOrderSelector,
  getOrderFormIsGiftReceiptOrderSelector,
  getOrderFormPromoCodeAppliedSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import featureConstants from '@constants/featureConstants';
import { FeatureFlagType } from 'types/FeatureFlag.types';

const orderTotalsOrderFormState = createSelector(
  [
    getOrderFormAmountsSelector,
    getOrderFormIsGiftReceiptOrderSelector,
    getOrderFormIsClickCollectOrderSelector,
    getOrderFormPromoCodeAppliedSelector,
    getApplyRewardsApiCallActiveSelector,
    isBasketOrderTotalAlwaysVisibleFeatureActive,
    getConfigFeaturesSelector,
  ],
  (
    amounts,
    isGiftReceiptOrder,
    isClickCollectOrder,
    promotionalCode,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    features,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    basketOrderTotalAlwaysVisibleImpressionId:
      features?.find((f: FeatureFlagType) => f.id === featureConstants.BASKET_ORDER_TOTAL_ALWAYS_VISIBLE)
        ?.impressionId ?? '',
    isGiftReceiptOrder,
    isClickCollectOrder,
    promotionalCode,
  }),
);

const orderTotalsConfirmationPagePropsState = createSelector(
  [
    getConfirmationOrderAmountsSelector,
    getConfirmationIsMultiBatchSelector,
    getConfirmationOrderDeliveriesSelector,
    getConfirmationIsClickCollectOrderSelector,
    getConfirmationPromoCodeAppliedSelector,
    getApplyRewardsApiCallActiveSelector,
    isBasketOrderTotalAlwaysVisibleFeatureActive,
    getConfigFeaturesSelector,
  ],
  (
    amounts,
    isMultiBatch,
    deliveries,
    isClickCollectOrder,
    promotionalCode,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    features,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    basketOrderTotalAlwaysVisibleImpressionId:
      features?.find((f: FeatureFlagType) => f.id === featureConstants.BASKET_ORDER_TOTAL_ALWAYS_VISIBLE)
        ?.impressionId ?? '',
    isGiftReceiptOrder: !isMultiBatch && deliveries?.some((delivery) => delivery.isGiftReceiptOrder),
    isClickCollectOrder,
    promotionalCode,
  }),
);

export { orderTotalsConfirmationPagePropsState, orderTotalsOrderFormState };
